export default "__VITE_ASSET__DYiUMOD6__"